import template from "./not-have-organization-page.html";

const NotHaveOrganizationPage = {
  template: template,

  controller: class NotHaveOrganizationPageController {
    /* @ngInject */
    constructor($rootScope, $window, $scope, $state) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$state = $state;
    }
  },
};
export default NotHaveOrganizationPage;
